

export const Spinner = () => (
	<i className='fa fa-spinner fa-spin' aria-hidden='true'></i>
)